import { useTranslation } from 'react-i18next';
import Heading from '~/components/Shared/Heading/Heading';
import Page from '~/components/Shared/Layout/Page/Page';
import { useQuery } from '@tanstack/react-query';
import { instance } from '~/utils/api/api';
import { useToastError } from '~/utils/useToastError';
import Storage from '~/components/Storage/Storage';
import styles from './StoragePage.module.scss';

const StoragePage = () => {
  const { t } = useTranslation();
  const toastError = useToastError();

  const {
    data: assets,
    isLoading: isAssetsLoading,
    refetch: refetchAssets,
  } = useQuery({
    queryFn: async () => {
      const { data } = await instance.get('admin/assets', {
        params: {
          perPage: 100,
        },
      });
      return data;
    },
    queryKey: ['assets'],
    onError: error => {
      toastError(error);
    },
  });

  return (
    <Page heading={<Heading text={t('storage')} />}>
      <div className={styles.page}>
        <Storage
          assets={assets?.data ?? []}
          refetchAssets={refetchAssets}
          isLoading={isAssetsLoading}
        />
      </div>
    </Page>
  );
};

export default StoragePage;
